<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>
          {{ getCurrentCount() }}
        </strong> / {{ this.noticeListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:70px">
        <col style="width:30px">
        <col style="width:90px">
        <col style="width:auto">
        <col style="width:130px">
        <col style="width:140px">
        <col style="width:90px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name="" @change="toggleAllCheck($event.target.checked)"><label for=""></label></span></th>
          <th scope="col">번호</th>
          <th scope="col">카테고리</th>
          <th scope="col">제목</th>
          <th scope="col">등록일</th>
          <th scope="col">첨부파일</th>
          <th scope="col">조회수</th>
        </tr>
      </thead>
      <tbody>
        <tr
          :class="{ noti: notice.topNoticeYn === 'Y'}"
          v-for="(notice, index) in noticeList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input
                type="checkbox"
                :value="notice.noticeSeq"
                v-model="selectedNotices"
              >
              <label for=""></label></span>
          </td>
          <td>{{ getImportantNotice(notice) }}</td>
          <td><span class="medium">{{ checkEmptyCategory(notice.category) }}</span></td>
          <td class="subject"><a @click="toNotice(notice.noticeSeq)">{{ notice.title }}</a></td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ notice.createDate }}</span>
              <span class="time"></span>
            </div>
          </td>
          <td>

            <ul class="list_attatch">
              <li v-for="attach in notice.attachList"><a href="#none">{{ attach.name }}</a></li>
            </ul>
          </td>
          <td>{{ notice.viewCnt }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createNotice">등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedNotices">삭제</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminNoticeModule = 'adminNoticeModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedNotices: [],

      searchOptions: [
        { name: '전체', value: 'all' },
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminNoticeModule, [
      'requestNoticeList',
      'requestDeleteNotices'
    ]),

    createNotice() {
      this.$router.push({ name: "BoardNoticeCreatePage" })
    },

    getImportantNotice(notice) {
      if (notice.topNoticeYn === "Y") return "중요"
      else return notice.order
    },

    toNotice(noticeSeq) {
      this.$router.push({
        name: "BoardNoticeEditPage",
        params: { noticeSeq: noticeSeq.toString() },
      });
    },

    totalPages() {
      return Math.ceil(this.noticeListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestNoticeList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.noticeListCount)) {
        currentLastCount = this.noticeListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedNotices = []
        for (const notice of this.noticeList) {
          this.selectedNotices.push(notice.noticeSeq)
        }
      } else {
        this.selectedNotices = []
      }
    },

    async deleteSelectedNotices() {
      if (this.selectedNotices.length === 0) {
        alert('선택된 공지사항이 없습니다');
        return;
      }

      const { searchType, searchWord, currentPage } = this;
      const fetchNotices = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word };
        await this.requestNoticeList(params);
        if (isReset) {
          this.searchType = 'all';
        }
      };

      await this.requestDeleteNotices(this.selectedNotices);
      this.selectedNotices = [];

      await fetchNotices(currentPage);

      if (this.noticeList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchNotices(this.currentPage);
      }

      if (this.noticeList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchNotices(1, '', '', true);
      }
    },

    checkEmptyCategory(name) {
      if (name === "") {
        return "카테고리 없음"
      } else return name
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestNoticeList({currentPage, searchType, searchWord})
    }
  },

  computed: {
    ...mapState(adminNoticeModule, [
      'noticeList',
      'noticeListCount'
    ])
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestNoticeList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">

</style>